<template>
    <div class="foot">
        <div class="footcontainer">
            <div class="footmenu">
                <div class="footlogo">
                    <div class="medialogo">
                        <a target="_blank" href="http://www.hrflag.com"><img src="http://hrflag.com/img/zqlogowt.svg" alt=""></a>
                    </div>
                    <div class="mediabody">
                        <p>COMPILE & RELEASE</p>
                    </div>
                </div>
                <span class="line">Nav</span>
                <router-link to="/english">Home</router-link>
                <router-link to="/zongshuEn">Research Overview</router-link>
                <router-link to="/brandEn">Best Global Brands</router-link>
                <router-link to="/countryEn">Ranking by Countries</router-link>
                <router-link to="/sectorEn">Ranking by Segments</router-link>
                <router-link to="/downloadEn">Download</router-link>
                <router-link to="/sourcesEn">Methodology</router-link>
                <router-link to="/copyrightEn">Copyright Notice</router-link>
                <router-link to="/organizationEn">Release Institue</router-link>
                <router-link to="/contactEn">Contact Us</router-link>
                <router-link to="/">中文</router-link>
                <span class="line">Contact Us</span>
                <div class="foot-contact">
                    <span class="adress">SHANGHAI： </span>
                    <a class="duan" target="_blank" href="tel:021-68405597">
                        <Icon type="ios-telephone"></Icon> <span>021-68405597</span>
                    </a>
                    <a class="duan" target="_blank" href="mailto:mag@hrflag.com">
                        <Icon type="email"></Icon> <span>mag@hrflag.com</span>
                    </a>
                    <a href="javascript:;">
                        <Icon type="ios-location"></Icon> <span>Room 404, Block B, Golden Eagle Building, No. 80 Hanxiao Road, Pudong New Area, Shanghai</span>
                    </a>
                </div>
                <div class="foot-contact">
                    <span class="adress madress">BEIJING： </span>
                    <a class="duan" target="_blank" href="tel:18701650657">
                        <Icon type="ios-telephone"></Icon> <span>18701650657</span>
                    </a>
                    <a class="duan" target="_blank" href="mailto:dove@hrflag.com">
                        <Icon type="email"></Icon> <span>dove@hrflag.com</span>
                    </a>
                    <a href="javascript:;">
                        <Icon type="ios-location"></Icon> <span>3rd Floor, Air China Century Building, 40 Xiaoyun Road, Chaoyang District, Beijing</span>
                    </a>
               </div>
               <div class="foot-contact">
                    <span class="adress madress">SHENZHEN： </span>
                    <a class="duan" target="_blank" href="tel:0755-33128064">
                        <Icon type="ios-telephone"></Icon> <span>0755-33128064</span>
                    </a>
                    <a class="duan" target="_blank" href="mailto:ancy@hrflag.com">
                        <Icon type="email"></Icon> <span>ancy@hrflag.com</span>
                    </a>
                    <a href="javascript:;">
                        <Icon type="ios-location"></Icon> <span>9th Floor, Block B, TCL Building, No. 6, Gaoxin South 1st Road, Nanshan District, Shenzhen</span>
                    </a>
               </div>
            </div>
            <div class="icp">
                <a href="javascript:;">HRflag Corp. © 2022　沪ICP备19003683号</a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'enfoot',
    data () {
        return {

        }
    }
}
</script>

<style scoped>
    .foot {
        width: 100%;
        background-color: #333333;
        padding: 0 0 20px 0;
        z-index: 3;
    }
    .footcontainer {
        max-width: 1440px;
        margin: 0 auto;
        text-align: left;
        padding: 30px 50px;
    }
    .footmenu .footlogo{
        width: 280px;
        margin: 0 auto;
    }
    .footlogo img {
        width: 100px;
        margin-right: 10px;
    }
    .footlogo .medialogo {
        display: table-cell;
        vertical-align: middle;
    }
    .footlogo .medialogo a {
        margin:0;
    }
    .footlogo .mediabody {
        display: table-cell;
        vertical-align: middle;
    }
    .mediabody p {
        color: #ffffff;
        font-size: 14px;
        padding-left: 10px;
    }
    .footmenu a{
        font-weight: normal;
        margin-right: 45px;
        font-size: 16px;
        color: #fff;
        line-height: 3;
        display: inline-block;
    }
    .foot-contact span.adress {
        width: 100px;
        display: inline-block;
        color: #999;
        font-size: 14px;
        font-weight: bold;
    }
    .foot-contact a {
        display: inline-block;
        color: #999;
        line-height: 2.5;
        width: auto;
        font-size: 14px;
        vertical-align: middle;
    }
    .foot-contact a.duan {
        width: 150px;
    }
    .foot-contact a i {
        vertical-align: middle;
        font-size: 18px;
    }
     .foot-contact a span {
         vertical-align: middle;
     }
     .footmenu a:hover {
         color: #1e6da6;
     }
     .footmenu .line {
        display: inline-block;
        padding: 0 0 0.5em 0;
        width: 100%;
        margin: .8em 0.5em 1em 0;
        text-align: left;
        color: #848484;
        opacity: 0.9;
        border-bottom: 2px solid;
        font-weight: bold;
    }
    .footcontainer .icp {
        text-align: center;
        margin-top: 50px;
    }
    .icp a {
        color:#848484;
    }
    @media screen and (max-width:768px) {
         .foot {
            min-width: 320px;
            padding: 0 10px;
        }
        .footcontainer {
            width: 100%;
            padding: 15px 0;
        }
         .footmenu a {
            font-size: 14px;
            color: #fff;
            display: inline-block;
            width: 32%;
            margin: 0;
            line-height: 2;
        }
        .foot-contact a {
            color: #999;
        }
        .mediabody p {
            color: #ffffff;
            font-size: 14px;
        }
        .foot-contact span.madress {
            margin-top: 10px;
            display: block;
        }
        .foot-contact a {
            display: block;
            width: 100%;
        }
        .icp a {
            color: #848484;
            font-size: 12px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/public/enfoot.vue